import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { outcomes } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-green-deep py-12 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-93" data-mp="3qtjemy0see2f">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-94" data-mp="3vscgft6pogmr">
        <p className="eyebrow text-gold-soft" data-id="element-95" data-mp="3vrumj37iuei0">El próximo lunes</p>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-display text-[1.9rem] font-bold leading-[1.1] text-shell sm:text-[2.5rem]" data-id="element-96" data-mp="2y5x1ay1rbv2d">
          Deja de improvisar. Empieza a enseñar{' '}
          <span className="text-gold-soft" data-id="element-97" data-mp="3820a2mr46rya">con sistema</span>.
        </h2>
        <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-shell/80" data-id="element-98" data-mp="3cu9z80kennzi">
          Miles de docentes de habla hispana ya planifican su año en menos de 10
          minutos. ¿Cuántas clases más quieres improvisar?
        </p>

        <ul className="mx-auto mt-9 grid max-w-2xl gap-x-8 gap-y-3 text-left sm:grid-cols-2" data-id="element-99" data-mp="2kbmfopl24h0j">
          {outcomes.map(outcome => <li key={outcome.text} className={`flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed ${outcome.positive ? 'font-semibold text-gold-soft' : 'text-shell/70'}`} data-id="element-100" data-mp="28cx7387z14sy">
              {outcome.positive ? <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-soft" strokeWidth={2.6} aria-hidden="true" data-id="element-101" data-mp="1yn3zeiay99tz" /> : <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-shell/45" strokeWidth={2.6} aria-hidden="true" data-id="element-102" data-mp="1ul8xbbl72sf5" />}
              {outcome.text}
            </li>)}
        </ul>

        <CtaButton size="large" className="mt-10 !bg-gold !text-green-deep hover:!bg-gold-soft" data-id="element-103" data-mp="1poigun5h9ut7">
          Quiero mi MEGAPACK
        </CtaButton>

        <p className="mt-5 font-sans text-[11px] text-shell/70" data-id="element-104" data-mp="1fp1cqa5vjozc">
          Pago seguro · acceso inmediato · garantía de 7 días sin riesgos
        </p>
      </div>
    </section>;
}